import React, { useState, useEffect } from 'react';

// --- Shared Tailwind Classes from your existing UI ---
const inputClasses = "w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 outline-none transition-all";
const sectionInputClasses = "w-full p-2 border border-gray-200 rounded-md focus:ring-1 focus:ring-teal-400 outline-none text-sm";
const dashedButton = "w-full py-4 border-2 border-dashed border-gray-300 rounded-xl text-gray-500 font-bold hover:border-teal-500 hover:text-teal-600 transition-all mt-4";
const primaryColor = "bg-teal-600 hover:bg-teal-700 active:scale-95 transition-all";

// const SectionTitle = ({ children }) => (
//     <h4 className="text-lg font-bold mt-4 mb-2 uppercase text-[#198754] border-b border-[#198754]/50 pb-1">{children}</h4>
// );

const initialUserDetails = {
    // CV Data Fields
    title: 'Senior Data Engineer CV',
    full_name: 'Dabirah AFolayan',
    email: 'john.daniel@gmail.com',
    phone: '+2348012345678',
    country: 'Nigeria',
    city: 'Lagos',
    home_address: '123 Tech Drive',
    postal_code: '100001',
    linkedin_url: 'https://linkedin.com/in/johndaniel',
    portfolio_url: 'https://github.com/johndaniel',
    professional_summary: 'Highly experienced and results-driven Senior Data Engineer with 7+ years in building scalable data pipelines, optimizing ETL processes, and migrating complex on-premise systems to cloud platforms (AWS/GCP). Proven ability to drive data governance and implement robust data warehousing solutions.',
    skills: ['React, Node.js, Python, SQL, AWS, Docker'],
    work_experiences: [{ id: 1, job_title: 'Senior Data Engineer', company: 'TechCorp Solutions', location: 'Lagos, Nigeria', dates: '2021 - Present', responsibilities: '• Designed and implemented real-time data ingestion pipelines using Kafka and Flink.\n• Led migration of petabyte-scale data warehouse from on-premise to AWS Redshift, reducing query latency by 40%.\n• Mentored junior engineers on best practices for SQL optimization and Python development.' }],
    educations: [{ id: 1, degree: 'B.Sc Computer Science', institution: 'University of Lagos', location: 'Lagos, Nigeria', dates: '2015 - 2019', achievements: 'Graduated with First Class Honors' }],
    projects: [{ id: 1, name: 'Customer Churn Prediction Model', url: 'https://github.com/johndaniel/churn', dates: '2023', summary: 'Developed a machine learning model using PySpark to predict customer churn with 92% accuracy, leading to targeted retention campaigns.' }],
    certifications: [{ id: 1, name: 'AWS Certified Solutions Architect', certificate_id: 'AWS-12345', url: 'https://aws.amazon.com/cert', dates: '2023/02/02', issuing_organization: 'Amazon Web Services', summary: '• Graduated among top 0.1%.\n• Learnt AWS at full-scale' }],

    // Template ID for the API call
    template_id: null,

    // Placeholder for the CV ID returned by the API after creation
    createdCvId: null,
};

//   / Helper function to render bulleted lists from newline-separated text
// const ListRenderer = ({ text }) => {
//     if (!text) return null;
//     const items = text.split('\n').filter(line => line.trim() !== '');
//     return (
//         <ul className="list-disc ml-5 space-y-1">
//             {items.map((item, index) => (
//                 <li key={index}>{item.replace(/^(\s*[\•\-\*]\s*)/, '')}</li>
//             ))}
//         </ul>
//     );
// };

const Guest = () => {
    const [step, setStep] = useState('templates'); // 'templates' | 'form' | 'payment'
    const [isSubmitting, setIsSubmitting] = useState(false);
    //   const [selectedTemplate, setSelectedTemplate] = useState(1);
    const [userDetails, setUserDetails] = useState(initialUserDetails);

    // Implementing the template endpoint now:
    const [templates, setTemplates] = useState([]);
    const [loadingTemplates, setLoadingTemplates] = useState(true);
    const [showPaymentNotice, setShowPaymentNotice] = useState(false);

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const res = await fetch('https://cv.signup.com.ng/v1/api/templates');
                const data = await res.json();

                if (data.status === "success") {
                    setTemplates(data.data);
                }
            } catch (err) {
                console.error("Failed to fetch templates:", err);
            } finally {
                setLoadingTemplates(false);
            }
        };

        fetchTemplates();
    }, []);

    // useEffect(() => {
    //     if (showPaymentNotice) {
    //         const timer = setTimeout(() => {
    //             setShowPaymentNotice(false);
    //         }, 10000);

    //         return () => clearTimeout(timer);
    //     }
    // }, [showPaymentNotice]);

    const getThumbnailUrl = (pdfUrl) => {
        return pdfUrl
            .replace('/upload/', '/upload/w_600,c_fit/')
            .replace('.pdf', '.jpg');
    };

    const transformedSkills = typeof userDetails.skills === 'string'
        ? userDetails.skills.split(',').map(s => s.trim()).filter(s => s !== '')
        : (Array.isArray(userDetails.skills) ? userDetails.skills : []);

    const transformedWorkExperiences = (userDetails.work_experiences || []).map(exp => ({
        job_title: exp.job_title,
        company: exp.company,
        location: exp.location,
        dates: exp.dates,
        responsibilities: exp.responsibilities ? exp.responsibilities.split('\n').filter(line => line.trim() !== '') : [],
    }));

    const transformedEducations = (userDetails.educations || []).map(edu => ({
        degree: edu.degree,
        institution: edu.institution,
        location: edu.location,
        dates: edu.dates,
        achievements: edu.achievements || '',
    }));

    const transformedProjects = (userDetails.projects || []).map(p => ({
        name: p.name,
        url: p.url,
        dates: p.dates,
        summary: p.summary,
    }));

    const transformedCertifications = (userDetails.certifications || []).map(c => ({
        name: c.name,
        certificate_id: c.certificate_id,
        url: c.url,
        dates: c.dates,
        issuing_organization: c.issuing_organization,
        summary: c.summary
    }));

    // 2. Construct the final API payload
    const finalPayload = {
        title: userDetails.title,
        template_id: userDetails.template_id,
        full_name: userDetails.full_name,
        email: userDetails.email,
        phone: userDetails.phone,
        country: userDetails.country,
        city: userDetails.city,
        home_address: userDetails.home_address,
        postal_code: userDetails.postal_code,
        linkedin_url: userDetails.linkedin_url,
        portfolio_url: userDetails.portfolio_url,
        professional_summary: userDetails.professional_summary,
        work_experiences: transformedWorkExperiences,
        skills: transformedSkills,
        educations: transformedEducations,
        projects: transformedProjects,
        certifications: transformedCertifications,
    };

    const [paymentDetails, setPaymentDetails] = useState(null);

    // --- Logic Handlers ---
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUserDetails(prev => ({ ...prev, [name]: value }));
    };

    const handleAddEntry = (section) => {
        const newEntry = { id: Date.now() };
        setUserDetails(prev => ({ ...prev, [section]: [...prev[section], newEntry] }));
    };

    const handleRemoveEntry = (section, id) => {
        setUserDetails(prev => ({ ...prev, [section]: prev[section].filter(item => item.id !== id) }));
    };

    const handleSectionChange = (section, id, field, value) => {
        setUserDetails(prev => ({
            ...prev,
            [section]: prev[section].map(item => item.id === id ? { ...item, [field]: value } : item)
        }));
    };



    const selectTemplate = (id) => {
        const numericId = parseInt(id, 10);
        // forcing template_id to be a numeric id

        setUserDetails(prev => ({
            ...prev,
            template_id: numericId
        }));

        setStep('form');
    };

    // const SelectedTemplate = CV_TEMPLATES.find(
    //     t => t.id === userDetails.template_id
    // )?.FullComponent;



    // const handleFormSubmit = async (e) => {
    //     e.preventDefault();
    //     setIsSubmitting(true);

    //     console.log(JSON.stringify(finalPayload))
    //     console.log("-------------------")
    //     console.log("TYPE:", typeof userDetails.template_id);
    //     console.log("VALUE:", userDetails.template_id);
    //     console.log("FINAL PAYLOAD:", finalPayload);

    //     try {
    //         const response = await fetch('https://cv.signup.com.ng/v1/api/guest/cvs/purchase', {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify(finalPayload),
    //         });
    //         const result = await response.json();
    //         console.log(response) // Seeing the output of the response
    //         console.log(result) // Seeing the result of the response
    //         if (!response.ok) {
    //             console.log("Validation Errors:", result.errors);
    //             alert(`Error: ${result.message || 'Validation failed'}`);
    //             // return;
    //         }
    //         //   if (result.success) { // Else, this should run
    //         console.log(result.virtual_account);
    //         setPaymentDetails(result.virtual_account);
    //         setStep('preview');
    //         //   }
    //     } catch (err) {
    //         console.error("Submission error:", err);
    //     } finally {
    //         setIsSubmitting(false);
    //     }
    // };

    const handleFormSubmit = (e) => {
        e.preventDefault();

        if (!userDetails.template_id) {
            alert("Please select a template first.");
            return;
        }

        setStep('preview');
    };

    const handleConfirmAndGeneratePayment = async () => {
        setIsSubmitting(true);

        try {
            const response = await fetch(
                'https://cv.signup.com.ng/v1/api/guest/cvs/purchase',
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(finalPayload),
                }
            );

            const result = await response.json();

            if (!response.ok) {
                // alert(result.message || "Validation failed");
                console.log("result value", result)
                console.log("result.message value", result.message)
                return;
            }

            setPaymentDetails(result.virtual_account);
            setStep('payment');

        } catch (err) {
            console.error("Submission error:", err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
            {/* Navbar */}
            <nav className="bg-white border-b px-6 py-4 flex items-center justify-between sticky top-0 z-50">
                <button onClick={() => step === 'templates' ? (window.location.reload()) : setStep('templates')} className="text-gray-500 font-bold text-sm flex items-center">
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" /></svg>
                    {step === 'templates' ? 'Exit' : 'Change Template'}
                </button>
                <span className="font-black uppercase tracking-widest text-xs">CVGen Guest Mode</span>
                <div className="w-10" />
            </nav>

            <div className="flex-1 overflow-y-auto pb-20">
                {step === 'templates' && (
                    <div className="max-w-4xl mx-auto p-8 animate-in fade-in zoom-in-95 duration-300">
                        <h2 className="text-3xl font-black text-center mb-8">Select Your Template</h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                            {loadingTemplates ? (
                                <p>Loading templates...</p>
                            ) : (
                                templates.map(template => (
                                    <div
                                        key={template.id}
                                        onClick={() => selectTemplate(template.id)}
                                        className="cursor-pointer group"
                                    >
                                        <div className="aspect-[3/4] bg-white border-4 border-white shadow-lg group-hover:border-teal-500 transition-all rounded-lg overflow-hidden">
                                            <img
                                                src={getThumbnailUrl(template.url)}
                                                alt={template.name}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>

                                        <p className="text-center mt-4 font-bold text-gray-700">
                                            {template.name}
                                        </p>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                )}

                {step === 'form' && (
                    <div className="flex flex-col items-center p-4 sm:p-10 animate-in slide-in-from-bottom-4 duration-500">
                        <form onSubmit={handleFormSubmit} className="bg-white p-6 sm:p-10 rounded-xl shadow-2xl w-full max-w-3xl">
                            {/* 1. PERSONAL DETAILS SECTION */}
                            <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">1. Personal Details & Summary</h2>
                            <div className="space-y-4">
                                <input type="text" name="title" value={userDetails.title} onChange={handleInputChange} placeholder="CV Title (e.g., Senior Staff Data Engineer CV)" className={inputClasses} required />
                                <input type="text" name="full_name" value={userDetails.full_name} onChange={handleInputChange} placeholder="Full Name" className={inputClasses} required />
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <input type="email" name="email" value={userDetails.email} onChange={handleInputChange} placeholder="Email" className={inputClasses} required />
                                    <input type="text" name="phone" value={userDetails.phone} onChange={handleInputChange} placeholder="Phone Number" className={inputClasses} />
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <input type="text" name="country" value={userDetails.country} onChange={handleInputChange} placeholder="Country" className={inputClasses} />
                                    <input type="text" name="city" value={userDetails.city} onChange={handleInputChange} placeholder="City" className={inputClasses} />
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <input type="text" name="home_address" value={userDetails.home_address} onChange={handleInputChange} placeholder="Home Address" className={inputClasses} />
                                    <input type="text" name="postal_code" value={userDetails.postal_code} onChange={handleInputChange} placeholder="Postal Code" className={inputClasses} />
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <input type="url" name="linkedin_url" value={userDetails.linkedin_url} onChange={handleInputChange} placeholder="LinkedIn URL" className={inputClasses} />
                                    <input type="url" name="portfolio_url" value={userDetails.portfolio_url} onChange={handleInputChange} placeholder="Portfolio URL" className={inputClasses} />
                                </div>
                                <textarea
                                    name="professional_summary" value={userDetails.professional_summary} onChange={handleInputChange}
                                    placeholder="Professional Summary (Required)"
                                    rows="5" className={`${inputClasses} resize-y`} required
                                />
                            </div>

                            {/* 2. WORK EXPERIENCE SECTION */}
                            <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">2. Work Experience</h2>
                            <div className="space-y-6">
                                {(userDetails.work_experiences || []).map((job) => (
                                    <div key={job.id} className="p-5 border border-gray-200 rounded-xl bg-gray-50 relative shadow-sm">
                                        <button type="button" onClick={() => handleRemoveEntry('work_experiences', job.id)} className="absolute top-3 right-3 text-gray-400 hover:text-red-500 transition duration-150 p-1 rounded-full bg-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm6 0a1 1 0 10-2 0v6a1 1 0 102 0V8z" clipRule="evenodd" /></svg>
                                        </button>
                                        <h3 className="text-lg font-semibold mb-3 text-gray-700">Role: {job.job_title || 'New Role'}</h3>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                            <input type="text" value={job.job_title} onChange={(e) => handleSectionChange('work_experiences', job.id, 'job_title', e.target.value)} placeholder="Job Title" className={sectionInputClasses} required />
                                            <input type="text" value={job.company} onChange={(e) => handleSectionChange('work_experiences', job.id, 'company', e.target.value)} placeholder="Company" className={sectionInputClasses} required />
                                            <input type="text" value={job.location} onChange={(e) => handleSectionChange('work_experiences', job.id, 'location', e.target.value)} placeholder="Location" className={sectionInputClasses} required />
                                            <input type="text" value={job.dates} onChange={(e) => handleSectionChange('work_experiences', job.id, 'dates', e.target.value)} placeholder="Dates (e.g., 2020 - 2024)" className={sectionInputClasses} required />
                                        </div>
                                        <textarea
                                            value={job.responsibilities}
                                            onChange={(e) => handleSectionChange('work_experiences', job.id, 'responsibilities', e.target.value)}
                                            placeholder="Key responsibilities. Enter each point on a new line."
                                            rows="4" className={`${sectionInputClasses} w-full resize-y`} required
                                        />
                                    </div>
                                ))}
                                <button type="button" onClick={() => handleAddEntry('work_experiences')} className={dashedButton}>
                                    + Add Work Experience Entry
                                </button>
                            </div>

                            {/* 3. SKILLS SECTION */}
                            <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">3. Skills</h2>
                            <div className="space-y-4">
                                <p className="text-sm text-slate-400 font-medium">Capture your expertise. Use commas to separate each skill.</p>
                                <textarea
                                    value={userDetails.skills || ''}
                                    onChange={(e) => setUserDetails({ ...userDetails, skills: e.target.value })}
                                    placeholder="e.g. React, Project Management, Python"
                                    rows="3"
                                    className={inputClasses + " resize-y min-h-[100px] border-dashed border-2"}
                                />
                                <div className="flex flex-wrap gap-2 mt-2">
                                    {(() => {
                                        const skillsData = userDetails.skills;
                                        let skillsArray = [];

                                        if (Array.isArray(skillsData)) {
                                            // If it's already an array, use it directly
                                            skillsArray = skillsData;
                                        } else if (typeof skillsData === 'string' && skillsData.trim() !== '') {
                                            // If it's a string, split it
                                            skillsArray = skillsData.split(',');
                                        }

                                        return skillsArray
                                            .map(s => String(s).trim()) // Ensure every element is a trimmed string
                                            .filter(s => s !== '')      // Remove empty strings
                                            .map((skill, index) => (
                                                <span
                                                    key={index}
                                                    className="px-3 py-1 bg-green-50 text-[#198754] text-xs font-bold rounded-full border border-green-100"
                                                >
                                                    {skill}
                                                </span>
                                            ));
                                    })()}
                                </div>
                            </div>

                            {/* 4. EDUCATION SECTION */}
                            <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">4. Education Background</h2>
                            <div className="space-y-6">
                                {(userDetails.educations || []).map((edu) => (
                                    <div key={edu.id} className="p-5 border border-gray-200 rounded-xl bg-gray-50 relative shadow-sm">
                                        <button type="button" onClick={() => handleRemoveEntry('educations', edu.id)} className="absolute top-3 right-3 text-gray-400 hover:text-red-500 transition duration-150 p-1 rounded-full bg-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm6 0a1 1 0 10-2 0v6a1 1 0 102 0V8z" clipRule="evenodd" /></svg>
                                        </button>
                                        <h3 className="text-lg font-semibold mb-3 text-gray-700">Study: {edu.degree || 'New Degree'}</h3>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                            <input type="text" value={edu.degree} onChange={(e) => handleSectionChange('educations', edu.id, 'degree', e.target.value)} placeholder="Degree" className={sectionInputClasses} required />
                                            <input type="text" value={edu.institution} onChange={(e) => handleSectionChange('educations', edu.id, 'institution', e.target.value)} placeholder="Institution" className={sectionInputClasses} required />
                                            <input type="text" value={edu.location} onChange={(e) => handleSectionChange('educations', edu.id, 'location', e.target.value)} placeholder="Location" className={sectionInputClasses} required />
                                            <input type="text" value={edu.dates} onChange={(e) => handleSectionChange('educations', edu.id, 'dates', e.target.value)} placeholder="Dates (e.g., 2015 - 2019)" className={sectionInputClasses} required />
                                        </div>
                                        <textarea
                                            value={edu.achievements}
                                            onChange={(e) => handleSectionChange('educations', edu.id, 'achievements', e.target.value)}
                                            placeholder="Achievements (e.g., Graduated with First Class Honors)"
                                            rows="3" className={`${sectionInputClasses} w-full resize-y`}
                                        />
                                    </div>
                                ))}
                                <button type="button" onClick={() => handleAddEntry('educations')} className={dashedButton}>
                                    + Add Education Entry
                                </button>
                            </div>

                            {/* 5. PROJECTS SECTION */}
                            <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">5. Projects</h2>
                            <div className="space-y-6">
                                {(userDetails.projects || []).map((proj) => (
                                    <div key={proj.id} className="p-5 border border-gray-200 rounded-xl bg-gray-50 relative shadow-sm">
                                        <button type="button" onClick={() => handleRemoveEntry('projects', proj.id)} className="absolute top-3 right-3 text-gray-400 hover:text-red-500 p-1 rounded-full bg-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm6 0a1 1 0 10-2 0v6a1 1 0 102 0V8z" clipRule="evenodd" /></svg>
                                        </button>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                            <input type="text" value={proj.name} onChange={(e) => handleSectionChange('projects', proj.id, 'name', e.target.value)} placeholder="Project Name" className={sectionInputClasses} required />
                                            <input type="url" value={proj.url} onChange={(e) => handleSectionChange('projects', proj.id, 'url', e.target.value)} placeholder="Project URL" className={sectionInputClasses} />
                                            <input type="text" value={proj.dates} onChange={(e) => handleSectionChange('projects', proj.id, 'dates', e.target.value)} placeholder="Dates" className={sectionInputClasses} required />
                                        </div>
                                        <textarea
                                            value={proj.summary}
                                            onChange={(e) => handleSectionChange('projects', proj.id, 'summary', e.target.value)}
                                            placeholder="Project Summary"
                                            rows="3" className={`${sectionInputClasses} w-full resize-y`} required
                                        />
                                    </div>
                                ))}
                                <button type="button" onClick={() => handleAddEntry('projects')} className={dashedButton}>
                                    + Add Project Entry
                                </button>
                            </div>

                            {/* 6. CERTIFICATIONS SECTION */}
                            <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-800 border-b pb-2">6. Certifications</h2>
                            <div className="space-y-6">
                                {(userDetails.certifications || []).map((cert) => (
                                    <div key={cert.id} className="p-5 border border-gray-200 rounded-xl bg-gray-50 relative shadow-sm">
                                        <button type="button" onClick={() => handleRemoveEntry('certifications', cert.id)} className="absolute top-3 right-3 text-gray-400 hover:text-red-500 transition duration-150 p-1 rounded-full bg-white" title="Remove Certification Entry">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm6 0a1 1 0 10-2 0v6a1 1 0 102 0V8z" clipRule="evenodd" /></svg>
                                        </button>
                                        {/* { console.log(cert) } */}
                                        <h3 className="text-lg font-semibold mb-3 text-gray-700">Cert: {cert.name || 'New Certification'}</h3>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                            <input type="text" value={cert.name} onChange={(e) => handleSectionChange('certifications', cert.id, 'name', e.target.value)} placeholder="Name" className={sectionInputClasses} required />
                                            <input type="text" value={cert.certificate_id} onChange={(e) => handleSectionChange('certifications', cert.id, 'certificate_id', e.target.value)} placeholder="Certificate ID" className={sectionInputClasses} />
                                            <input type="url" value={cert.url} onChange={(e) => handleSectionChange('certifications', cert.id, 'url', e.target.value)} placeholder="Certificate URL" className={sectionInputClasses} />
                                            <input type="date" value={cert.dates} onChange={(e) => handleSectionChange('certifications', cert.id, 'dates', e.target.value)} placeholder="Dates (e.g., 02/02/2023)" className={sectionInputClasses} required />
                                            <input type="text" value={cert.issuing_organization} onChange={(e) => handleSectionChange('certifications', cert.id, 'issuing_organization', e.target.value)} placeholder="Issuing Organization" className={sectionInputClasses} required />
                                            <span className="hidden sm:block"></span>
                                        </div>
                                        <textarea
                                            value={cert.summary}
                                            onChange={(e) => handleSectionChange('certifications', cert.id, 'summary', e.target.value)}
                                            placeholder="Certificate Summary"
                                            rows="3" className={`${sectionInputClasses} w-full resize-y`} required
                                        />
                                    </div>
                                ))}
                                <button type="button" onClick={() => handleAddEntry('certifications')} className={dashedButton}>
                                    + Add Certification Entry
                                </button>
                            </div>

                            {/* FORM SUBMISSION */}
                            <div className="flex flex-col items-center mt-10">
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`px-12 py-4 rounded-full font-black text-white shadow-xl ${primaryColor} disabled:opacity-50`}
                                >
                                    {isSubmitting ? "Processing..." : "Preview Details"}
                                </button>
                            </div>
                        </form>
                    </div>
                )}

                {step === 'preview' && (
                    <div className="max-w-3xl mx-auto p-8 bg-white shadow-xl rounded-xl space-y-6">

                        <h2 className="text-2xl font-bold text-gray-800">
                            Confirm Your Details
                        </h2>

                        <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded">
                            <p className="text-sm text-yellow-800">
                                Your CV will be sent to this email:
                            </p>
                            <p className="font-bold text-lg text-teal-600">
                                {userDetails.email}
                            </p>
                        </div>

                        <div className="space-y-2 text-gray-700">
                            <p><strong>Full Name:</strong> {userDetails.full_name}</p>
                            <p><strong>Phone:</strong> {userDetails.phone}</p>
                            <p><strong>Template ID:</strong> {userDetails.template_id}</p>
                            {/* <p><strong>Note:</strong> The Amount charged for a CV without a referral link is: <b>₦3000</b>, as opposed to <b>₦2500</b> when with a referral link. To get A referral link and start earning commissions from ₦500 - up to ₦2000 naira, kindly sign up for an account today :) </p> */}
                            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-3">
                                <p className="font-semibold text-gray-800">
                                    CV Pricing
                                </p>

                                <div className="flex justify-between text-sm">
                                    <span>Guest Checkout</span>
                                    <span className="font-bold text-red-500">₦3000</span>
                                </div>

                                <div className="flex justify-between text-sm">
                                    <span>With Referral Link</span>
                                    <span className="font-bold text-green-600">₦2500</span>
                                </div>

                                <p className="text-xs text-gray-600">
                                    Create an account to get a referral link and earn commissions between
                                    <b> ₦500 - ₦2000 </b> whenever someone generates a CV through your link.
                                </p>
                                {/* Depending on if Users don't have an account, /auth/callback would require them to create an account through signup.co */}
                                <a
                                    href="https://cv.signup.com.ng/auth/callback"
                                    className="inline-block text-sm text-blue-600 font-semibold hover:underline"
                                >
                                    Create an account & start earning →
                                </a>
                            </div>
                        </div>

                        <div className="flex justify-between pt-6">
                            <button
                                onClick={() => setStep('form')}
                                className="px-6 py-2 border rounded-lg"
                            >
                                Go Back & Edit
                            </button>

                            <button
                                onClick={handleConfirmAndGeneratePayment}
                                disabled={isSubmitting}
                                className={`px-8 py-3 text-white rounded-lg font-semibold ${primaryColor}`}
                            >
                                {isSubmitting ? "Generating Payment..." : "Confirm & Get Payment Details"}
                            </button>
                        </div>
                    </div>
                )}

                {step === 'payment' && paymentDetails && (
                    <div className="max-w-md mx-auto p-4 pt-10 animate-in zoom-in-95 duration-300">
                        <div className="bg-white rounded-3xl overflow-hidden shadow-2xl border border-gray-100">
                            <div className="bg-teal-700 p-8 text-white text-center">
                                <h2 className="text-4xl font-black mb-1">₦{paymentDetails.amount}</h2>
                                <p className="text-teal-100 text-[10px] uppercase tracking-widest font-bold">Transfer to Account Below</p>
                            </div>
                            <div className="p-8 space-y-6">
                                <div className="p-6 bg-gray-50 rounded-2xl text-center">
                                    <p className="text-[10px] text-gray-400 font-bold uppercase mb-1">Bank Name</p>
                                    <p className="text-lg font-bold mb-4">{paymentDetails.bankName}</p>
                                    <p className="text-[10px] text-gray-400 font-bold uppercase mb-1">Account Name</p>
                                    <p className="text-2xl font-mono font-black text-teal-600">
                                        {paymentDetails.accountName}
                                    </p>
                                    <p className="text-[10px] text-gray-400 font-bold uppercase mb-1">Account Number</p>
                                    <p className="text-2xl font-mono font-black text-teal-600">
                                        {paymentDetails.accountNumber}
                                    </p>
                                    <p className="text-[10px] text-gray-400 font-bold uppercase mb-1">Delivery Email</p>
                                    <p className="text-2xl font-mono font-black text-teal-600">
                                        {userDetails.email}
                                    </p>
                                </div>
                                <p className="text-xs text-gray-500 text-center leading-relaxed">
                                    {/* Please note that this bank details expires at: , anytime above that could lead to loss of funds</span> */}
                                    <span className='text-[#FFC107]'>Important Notice: </span> The CV will be sent to this delivery email: <span className='text-[#48BB78]'>{userDetails.email}</span> This virtual account will expire on <span className="text-[#E53E3E]">{paymentDetails.expire_at}. Do not make any transfers after this deadline, as funds sent beyond this time may not be recoverable.</span>
                                </p>
                                <p className="text-xs text-gray-500 text-center leading-relaxed">
                                    Once payment is confirmed, your completed CV will be generated using the selected template and sent to the email you inserted into the CV.
                                </p>
                                <button
                                    onClick={() => setShowPaymentNotice(true)}
                                    className="w-full py-4 bg-gray-900 text-white rounded-xl font-bold hover:bg-black transition-all"
                                >
                                    I've Sent the Payment
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showPaymentNotice && (
                    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 animate-in fade-in duration-300">

                        <div className="bg-white max-w-md w-full mx-4 rounded-2xl shadow-2xl p-8 space-y-6 text-center animate-in zoom-in-95 duration-300">

                            <div className="w-16 h-16 mx-auto bg-green-100 text-green-600 rounded-full flex items-center justify-center text-3xl">
                                ✓
                            </div>

                            <h2 className="text-2xl font-bold text-gray-800">
                                Payment Submitted
                            </h2>

                            <p className="text-gray-600 text-sm leading-relaxed">
                                Once your transfer is confirmed, your CV will be generated and sent to:
                            </p>

                            <p className="font-bold text-teal-600 break-all">
                                {userDetails.email}
                            </p>

                            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-xs text-yellow-800">
                                Please check your inbox and spam folder.
                                Delivery usually takes a few minutes after payment confirmation.
                            </div>

                            <button
                                onClick={() => {
                                    setShowPaymentNotice(false);
                                    window.location.reload();
                                    // If Asked not to refresh page: This gives you a cleaner reset than full reload.
                                    // setStep('templates');
                                    // setUserDetails(initialUserDetails);
                                }}
                                className={`w-full py-3 rounded-xl text-white font-bold ${primaryColor}`}
                            >
                                Okay
                            </button>

                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Guest;